import actionsTypes from "../actions/types";

export const defaultState = {
    "customers": 1,
    "customer": [],
    "number": -1,
    "payed": false,
    "products": [],
    "quantity": 0,
    "table": -1,
    "total": 0.0,
    "type": "restaurant",
    "order_note": "",
};

function roundTotal(value) {
    return Math.round(value * 100) / 100;
}

function checkGlassPrice(item) {
    return item.hasOwnProperty("use_glass_price") && item.use_glass_price;
}

function checkDishVariations(item) {
    return item.hasOwnProperty("use_variation");
}

function checkDishAdditions(item) {
    return item.hasOwnProperty("use_additions");
}

function adaptItem(item) {
    if (checkGlassPrice(item)) {
        let obj = Object.assign({}, item);
        obj.name = `${item.name} (Calice)`;
        obj.id = `${item.id}-v`;
        obj.price = item.glass_price;
        obj.original_name = obj.name;
        return obj;
    }
    if (checkDishVariations(item) || checkDishAdditions(item)) {
        let obj = Object.assign({}, item);
        if (checkDishVariations(item)) {
            obj.id = `${item.id}v-${item.use_variation.id}`;
            obj.name = `${item.name} (${item.use_variation.name.trim()})`;
            obj.original_name = `${item.original_name} (${item.use_variation.name.trim()})`;
            obj.price = item.use_variation.price;
        }
        if (checkDishAdditions(item)) {
            item.use_additions.forEach((addition, i) => {
                if (i === 0) {
                    obj.id = `${obj.id}a-${addition.id}`;
                    obj.name = `${obj.name} (Aggiunte: `;
                    obj.original_name = `${obj.original_name} (Aggiunte: `;
                }
                else {
                    obj.id = `${obj.id},${addition.id}`;
                }
                obj.name = `${obj.name.trim()} ${addition.name.trim()}`;
                obj.original_name = `${obj.original_name.trim()} ${addition.name.trim()}`;
                obj.price = obj.price + addition.price;
                (i !== item.use_additions.length - 1) ? obj.name = `${obj.name},` : obj.name = `${obj.name})`;
                (i !== item.use_additions.length - 1) ? obj.original_name = `${obj.original_name},` : obj.original_name = `${obj.original_name})`;
            });
        }

        return obj;
    }

    return item;
}

function reducer(state, action) {
    switch (action.type) {
        case actionsTypes.CART_ADD: {
            const note = action.payload.note?.trim() || "";
            const newProduct = {
                ...adaptItem(action.payload),
                "quantity": action.quantity,
                "note": note,
            };

            const price = checkGlassPrice(newProduct) ? newProduct.glass_price : newProduct.price;

            const existsIndex = state.products.findIndex(product => product.id === newProduct.id && product.note === note);

            const updatedProducts = existsIndex !== -1 ?
                state.products.map((product, i) => i === existsIndex ?
                    { ...product, "quantity": product.quantity + action.quantity } : product) :
                [...state.products, newProduct];

            return {
                ...state,
                "products": updatedProducts,
                "quantity": state.quantity + action.quantity,
                "total": roundTotal(state.total + (price * action.quantity)),
            };
        }
        case actionsTypes.CART_REMOVE: {
            let removedProduct = state.products.find(product => product.id === action.id);
            let newProducts = state.products.filter(product => product.id !== action.id);
            let newTotal = roundTotal(state.total - (removedProduct.price * removedProduct.quantity));
            let newQuantity = state.quantity - removedProduct.quantity;
            return {
                ...state,
                "products": newProducts,
                "quantity": newQuantity,
                "total": newTotal
            };
        }
        case actionsTypes.CART_ADDONE: {
            const index = state.products.findIndex(product => product.id === action.id && product.note === action.note);
            if (index === -1) {
                return state;
            };

            const updatedProducts = [...state.products];
            const product = updatedProducts[index];
            updatedProducts[index] = {
                ...product,
                "quantity": product.quantity + 1
            };

            const price = checkGlassPrice(product) ? product.glass_price : product.price;

            return {
                ...state,
                "products": updatedProducts,
                "quantity": state.quantity + 1,
                "total": roundTotal(state.total + price),
            };
        }
        case actionsTypes.CART_SUBONE: {
            const index = state.products.findIndex(product => product.id === action.id && product.note === action.note);

            if (index === -1) {
                return state;
            }

            const product = state.products[index];
            const price = checkGlassPrice(product) ? product.glass_price : product.price;

            const updatedProducts = product.quantity === 1 ?
                state.products.filter((_, i) => i !== index) :
                state.products.map((product, i) => i === index ? { ...product, quantity: product.quantity - 1 } : product);

            return {
                ...state,
                "products": updatedProducts,
                "quantity": state.quantity - 1,
                "total": roundTotal(state.total - price),
            };
        }
        case actionsTypes.CART_CLEAN: {
            return defaultState;
        }
        case actionsTypes.CART_TABLE: {
            return {
                ...state,
                "table": action.table
            };
        }
        case actionsTypes.CART_NUMBER: {
            return {
                ...state,
                "number": action.number
            };
        }
        case actionsTypes.CART_TYPE: {
            return {
                ...state,
                "type": action.order_type
            };
        }
        case actionsTypes.CART_ADDNOTE: {
            let product = state.products.find(product => product.id === action.id);
            product.note = action.note;
            return {
                ...state,
            };
        }
        case actionsTypes.CART_ADDORDERNOTE: {
            return {
                ...state,
                "order_note": action.order_note
            };
        }
        case actionsTypes.CART_CUSTOMERS: {
            return {
                ...state,
                customers: action.customers_number,
            };
        }
        case actionsTypes.CART_PAYED: {
            return {
                ...state,
                payed: action.payed,
            };
        }
        case actionsTypes.CART_CUSTOMER: {
            return {
                ...state,
                customer: action.customer,
            };
        }
        case actionsTypes.CART_DELIVERY: {
            return {
                ...state,
                deliveryCost: action.deliveryCost,
            };
        }
        default: {
            throw new Error(`Unhandled action type: ${action.type}`);
        }
    }
}

export default reducer;
